// extracted by mini-css-extract-plugin
export var dateLabel = "_3n-0";
export var dateLabelError = "_3n-1";
export var fullWidth = "_3n-2";
export var smaller = "_3n-3";